import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { getUrlBuilders, getUrlHelpers } from '@bingads-webui-clientcenter/url-builder-base';
import type { UrlBuilderContextProviderProps, UrlBuilderContextValue } from './types';

export const UrlBuilderContext = createContext<UrlBuilderContextValue>({});

export const UrlBuilderContextProvider = ({
  cid,
  aid,
  uid,
  ClientCenterBaseUrl: ccBaseUrl,
  FwLinkBaseUrl,
  children
}: UrlBuilderContextProviderProps) => {
  const urlBuilders = useMemo(() => getUrlBuilders({
    ccBaseUrl,
    cidFetcher: _.constant(cid),
    aidFetcher: _.constant(aid),
    uidFetcher: _.constant(uid),
    getDefaultIsShortUrl: _.constant(false),
  }), [ccBaseUrl, cid, aid, uid]);

  const urlHelper = useMemo(() => getUrlHelpers({
    ccBaseUrl,
    FwLinkBaseUrl,
    cid,
    uid,
  }), [ccBaseUrl, FwLinkBaseUrl, cid, uid]);

  const value = useMemo(() => ({ urlBuilders, urlHelper }), [urlBuilders, urlHelper]);

  return <UrlBuilderContext.Provider value={value}>{children}</UrlBuilderContext.Provider>;
};

UrlBuilderContextProvider.propTypes = {
  ClientCenterBaseUrl: PropTypes.string.isRequired,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number,
  uid: PropTypes.number,
  FwLinkBaseUrl: PropTypes.string,
  children: PropTypes.node.isRequired,
};


UrlBuilderContextProvider.defaultProps = {
  aid: undefined,
  uid: undefined,
  FwLinkBaseUrl: undefined,
};
